export default __webpack_public_path__ + "static/media/slackfairchance.7e05cba5.svg";